module.exports = __webpack_public_path__ + "img/xiaofeihuaxiang.6022de93.png";